import React, {useState} from "react";
import {Form} from "react-final-form";
import {useSelector} from "react-redux";
import Toast from "cogo-toast";
import Modal from "../../../components/My/Modal";
import {TurnstileButton as Button} from "../components/Button";
import ApiTurnstileTemplateField from "../../../FinalForm/api/ApiTurnstileTemplateField";
import ApiZoneSelectField from "../../../FinalForm/api/ApiZoneSelectField";
import ApiTariffSelectField from "../../../FinalForm/api/ApiTariffSelectField";
import {apiBulkUpdateTurnstile} from "./Actions";

const ToggleRow = ({checked, onChange, label, children}) => (
    <div style={{marginBottom: "16px"}}>
        <label style={{display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px", cursor: "pointer", fontSize: "var(--enigoo-fs-md)", fontWeight: 600, color: "#475569"}}>
            <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)}/>
            {label}
        </label>
        <div style={{opacity: checked ? 1 : 0.45, pointerEvents: checked ? "auto" : "none"}}>
            {children}
        </div>
    </div>
);

const BulkEditModal = ({selectedIds, close, onSaved}) => {
    const user = useSelector(s => s.user);
    const canEdit = !!user?.user?.rights?.enigooTurniketsEdit;
    const [applyTemplate, setApplyTemplate] = useState(false);
    const [applyZone, setApplyZone] = useState(false);
    const [applyTariff, setApplyTariff] = useState(false);
    const [saving, setSaving] = useState(false);

    const onSubmit = (values) => {
        if (!canEdit) return;
        if (!applyTemplate && !applyZone && !applyTariff) {
            Toast.warn("Vyberte alespoň jedno pole ke změně.");
            return;
        }
        const payload = {
            ids: Array.from(selectedIds),
            applyTemplate,
            turnstileTemplate: applyTemplate ? (values.turnstileTemplate ?? null) : null,
            applyZone,
            zone: applyZone ? (values.zone ?? null) : null,
            applyTariff,
            tariff: applyTariff ? (values.tariff ?? []) : null,
        };
        setSaving(true);
        apiBulkUpdateTurnstile(user.activeAreal.id, payload, (data) => {
            setSaving(false);
            const upd = data?.updated?.length ?? 0;
            const fail = data?.failed?.length ?? 0;
            if (fail > 0) Toast.warn("Upraveno " + upd + ", selhalo " + fail + ".");
            else Toast.success("Upraveno " + upd + " turniketů.");
            onSaved && onSaved();
            close();
        }, () => {
            setSaving(false);
            Toast.error("Hromadná úprava selhala.");
        });
    };

    return (
        <Form onSubmit={onSubmit} render={({handleSubmit}) => (
            <Modal
                visible={true}
                close={close}
                title={"Hromadná změna (" + selectedIds.size + ")"}
                body={
                    <>
                        <p style={{fontSize: "var(--enigoo-fs-sm)", color: "#94a3b8", marginTop: 0, marginBottom: "14px"}}>
                            Změní se pouze zaškrtnutá pole. Tarify nahradí stávající seznam.
                        </p>
                        <ToggleRow checked={applyTemplate} onChange={setApplyTemplate} label="Změnit šablonu turniketu">
                            <ApiTurnstileTemplateField name="turnstileTemplate" isMulti={false}/>
                        </ToggleRow>
                        <ToggleRow checked={applyZone} onChange={setApplyZone} label="Změnit zónu">
                            <ApiZoneSelectField name="zone" isMulti={false}/>
                        </ToggleRow>
                        <ToggleRow checked={applyTariff} onChange={setApplyTariff} label="Změnit tarify (nahradí stávající)">
                            <ApiTariffSelectField name="tariff" isMulti={true}/>
                        </ToggleRow>
                    </>
                }
                footer={
                    <>
                        <Button text={saving ? "Ukládám..." : "Uložit"} onClick={handleSubmit}/>
                        <Button text="Zrušit" color="outline" onClick={close}/>
                    </>
                }
            />
        )}/>
    );
};

export default BulkEditModal;
